'use client'

import { DialogPanel } from '@headlessui/react'
import { cn } from '@mntn-dev/ui-utilities'
import { motion } from 'motion/react'
import { type PropsWithChildren, forwardRef } from 'react'
import { type TestIds, getTestProps } from '../../utils/testing.ts'
import { modalDialogVariants } from './utils.ts'

export type ModalDialogProps = PropsWithChildren<
  TestIds & {
    className?: string
  }
>

export const ModalDialog = forwardRef<HTMLDivElement, ModalDialogProps>(
  ({ children, className, dataTestId, dataTrackingId }, ref) => {
    return (
      <DialogPanel
        as={motion.div}
        ref={ref}
        initial={modalDialogVariants.initial}
        animate={modalDialogVariants.open}
        exit={modalDialogVariants.initial}
        {...getTestProps({ dataTestId, dataTrackingId })}
        className={cn(
          'relative flex flex-col bg-container-secondary rounded-lg border border-subtle p-8',
          className
        )}
      >
        {children}
      </DialogPanel>
    )
  }
)
